/**
 * Generated by orval v6.8.0 🍺
 * Do not edit manually.
 * ITS Macros API
 * ITS Macros OpenApi description
 * OpenAPI spec version: 1.0.0
 */
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
export type UtilPostalCodes403Errors = { [key: string]: any };

export type UtilPostalCodes403 = {
	message?: string;
	errors?: UtilPostalCodes403Errors;
};

export type UtilPostalCodes401Errors = { [key: string]: any };

export type UtilPostalCodes401 = {
	message?: string;
	errors?: UtilPostalCodes401Errors;
};

export type UtilPostalCodes200 = {
	data?: PostalCode[];
};

export type UtilHealth200 = {
	healthy?: boolean;
};

export type UserPhotoUpdate404Errors = { [key: string]: any };

export type UserPhotoUpdate404 = {
	message?: string;
	errors?: UserPhotoUpdate404Errors;
};

export type UserPhotoUpdate403Errors = { [key: string]: any };

export type UserPhotoUpdate403 = {
	message?: string;
	errors?: UserPhotoUpdate403Errors;
};

export type UserPhotoUpdate401Errors = { [key: string]: any };

export type UserPhotoUpdate401 = {
	message?: string;
	errors?: UserPhotoUpdate401Errors;
};

export type UserPhotoUpdateBody = {
	/** photo */
	photo_id?: number | null;
};

export type UserPushTokenUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserPushTokenUpdate404Errors = { [key: string]: any };

export type UserPushTokenUpdate404 = {
	message?: string;
	errors?: UserPushTokenUpdate404Errors;
};

export type UserPushTokenUpdate403Errors = { [key: string]: any };

export type UserPushTokenUpdate403 = {
	message?: string;
	errors?: UserPushTokenUpdate403Errors;
};

export type UserPushTokenUpdate401Errors = { [key: string]: any };

export type UserPushTokenUpdate401 = {
	message?: string;
	errors?: UserPushTokenUpdate401Errors;
};

export type UserPushTokenUpdateBody = {
	push_token?: string | null;
};

export type UserNotesUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserNotesUpdate404Errors = { [key: string]: any };

export type UserNotesUpdate404 = {
	message?: string;
	errors?: UserNotesUpdate404Errors;
};

export type UserNotesUpdate403Errors = { [key: string]: any };

export type UserNotesUpdate403 = {
	message?: string;
	errors?: UserNotesUpdate403Errors;
};

export type UserNotesUpdate401Errors = { [key: string]: any };

export type UserNotesUpdate401 = {
	message?: string;
	errors?: UserNotesUpdate401Errors;
};

export type UserNotesUpdateBody = {
	/** note text content */
	notes?: string | null;
};

export type UserSpouseUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserSpouseUpdate404Errors = { [key: string]: any };

export type UserSpouseUpdate404 = {
	message?: string;
	errors?: UserSpouseUpdate404Errors;
};

export type UserSpouseUpdate403Errors = { [key: string]: any };

export type UserSpouseUpdate403 = {
	message?: string;
	errors?: UserSpouseUpdate403Errors;
};

export type UserSpouseUpdate401Errors = { [key: string]: any };

export type UserSpouseUpdate401 = {
	message?: string;
	errors?: UserSpouseUpdate401Errors;
};

export type UserSpouseUpdateBody = {
	/** spouse id */
	spouse_id?: number;
};

export type UserTeamUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserTeamUpdate404Errors = { [key: string]: any };

export type UserTeamUpdate404 = {
	message?: string;
	errors?: UserTeamUpdate404Errors;
};

export type UserTeamUpdate403Errors = { [key: string]: any };

export type UserTeamUpdate403 = {
	message?: string;
	errors?: UserTeamUpdate403Errors;
};

export type UserTeamUpdate401Errors = { [key: string]: any };

export type UserTeamUpdate401 = {
	message?: string;
	errors?: UserTeamUpdate401Errors;
};

export type UserTeamUpdateBody = {
	/** team id */
	team_id?: number;
};

export type UserRoleUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserRoleUpdate404Errors = { [key: string]: any };

export type UserRoleUpdate404 = {
	message?: string;
	errors?: UserRoleUpdate404Errors;
};

export type UserRoleUpdate403Errors = { [key: string]: any };

export type UserRoleUpdate403 = {
	message?: string;
	errors?: UserRoleUpdate403Errors;
};

export type UserRoleUpdate401Errors = { [key: string]: any };

export type UserRoleUpdate401 = {
	message?: string;
	errors?: UserRoleUpdate401Errors;
};

export type UserRoleUpdateBody = {
	role?: Role;
};

export type UserNameUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserNameUpdate404Errors = { [key: string]: any };

export type UserNameUpdate404 = {
	message?: string;
	errors?: UserNameUpdate404Errors;
};

export type UserNameUpdate403Errors = { [key: string]: any };

export type UserNameUpdate403 = {
	message?: string;
	errors?: UserNameUpdate403Errors;
};

export type UserNameUpdate401Errors = { [key: string]: any };

export type UserNameUpdate401 = {
	message?: string;
	errors?: UserNameUpdate401Errors;
};

export type UserNameUpdateBody = {
	name?: string;
};

export type UserEmailUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserEmailUpdate404Errors = { [key: string]: any };

export type UserEmailUpdate404 = {
	message?: string;
	errors?: UserEmailUpdate404Errors;
};

export type UserEmailUpdate403Errors = { [key: string]: any };

export type UserEmailUpdate403 = {
	message?: string;
	errors?: UserEmailUpdate403Errors;
};

export type UserEmailUpdate401Errors = { [key: string]: any };

export type UserEmailUpdate401 = {
	message?: string;
	errors?: UserEmailUpdate401Errors;
};

export type UserEmailUpdateBody = {
	email?: string;
};

export type UserDelete403Errors = { [key: string]: any };

export type UserDelete403 = {
	message?: string;
	errors?: UserDelete403Errors;
};

export type UserDelete401Errors = { [key: string]: any };

export type UserDelete401 = {
	message?: string;
	errors?: UserDelete401Errors;
};

export type UserDelete200 = {
	message?: string;
};

export type UserShow404Errors = { [key: string]: any };

export type UserShow404 = {
	message?: string;
	errors?: UserShow404Errors;
};

export type UserShow401Errors = { [key: string]: any };

export type UserShow401 = {
	message?: string;
	errors?: UserShow401Errors;
};

export type UserCreateAppStore422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserCreateAppStoreBody = {
	name: string;
	email: string;
	/** Start date of period */
	start_date: string;
	receipt: string;
};

export type UserCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type UserCreate403Errors = { [key: string]: any };

export type UserCreate403 = {
	message?: string;
	errors?: UserCreate403Errors;
};

export type UserCreate401Errors = { [key: string]: any };

export type UserCreate401 = {
	message?: string;
	errors?: UserCreate401Errors;
};

export type UserCreateBody = {
	name: string;
	role: Role;
	email: string;
	password: string | null;
	password_confirmation?: string | null;
	push_token?: string;
	/** note text content */
	notes?: string | null;
	/** team id */
	team_id?: number | null;
	/** spouse id */
	spouse_id?: number | null;
	/** Start date of period */
	start_date?: string;
	/** End date of period */
	end_date?: string;
	/** The starting day for the period */
	day_number?: number;
};

export type UserIndex403Errors = { [key: string]: any };

export type UserIndex403 = {
	message?: string;
	errors?: UserIndex403Errors;
};

export type UserIndex401Errors = { [key: string]: any };

export type UserIndex401 = {
	message?: string;
	errors?: UserIndex401Errors;
};

export type UserIndex200 = {
	data?: User[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type UserIndexParams = {
	search?: string;
	team_id?: number;
	page?: number;
	item_count?: number;
};

export type TeamDelete403Errors = { [key: string]: any };

export type TeamDelete403 = {
	message?: string;
	errors?: TeamDelete403Errors;
};

export type TeamDelete401Errors = { [key: string]: any };

export type TeamDelete401 = {
	message?: string;
	errors?: TeamDelete401Errors;
};

export type TeamDelete200 = {
	message?: string;
};

export type TeamUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type TeamUpdate403Errors = { [key: string]: any };

export type TeamUpdate403 = {
	message?: string;
	errors?: TeamUpdate403Errors;
};

export type TeamUpdate401Errors = { [key: string]: any };

export type TeamUpdate401 = {
	message?: string;
	errors?: TeamUpdate401Errors;
};

export type TeamUpdateBody = {
	/** team name */
	name?: string;
	/** Further information */
	description?: string;
};

export type TeamShow404Errors = { [key: string]: any };

export type TeamShow404 = {
	message?: string;
	errors?: TeamShow404Errors;
};

export type TeamShow401Errors = { [key: string]: any };

export type TeamShow401 = {
	message?: string;
	errors?: TeamShow401Errors;
};

export type TeamCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type TeamCreate403Errors = { [key: string]: any };

export type TeamCreate403 = {
	message?: string;
	errors?: TeamCreate403Errors;
};

export type TeamCreate401Errors = { [key: string]: any };

export type TeamCreate401 = {
	message?: string;
	errors?: TeamCreate401Errors;
};

export type TeamCreateBody = {
	/** team name */
	name?: string;
	/** Further information */
	description?: string;
};

export type TeamIndex404Errors = { [key: string]: any };

export type TeamIndex404 = {
	message?: string;
	errors?: TeamIndex404Errors;
};

export type TeamIndex401Errors = { [key: string]: any };

export type TeamIndex401 = {
	message?: string;
	errors?: TeamIndex401Errors;
};

export type TeamIndex200 = {
	data?: Team[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type TaskAnswerUpdatePhoto404Errors = { [key: string]: any };

export type TaskAnswerUpdatePhoto404 = {
	message?: string;
	errors?: TaskAnswerUpdatePhoto404Errors;
};

export type TaskAnswerUpdatePhoto403Errors = { [key: string]: any };

export type TaskAnswerUpdatePhoto403 = {
	message?: string;
	errors?: TaskAnswerUpdatePhoto403Errors;
};

export type TaskAnswerUpdatePhoto401Errors = { [key: string]: any };

export type TaskAnswerUpdatePhoto401 = {
	message?: string;
	errors?: TaskAnswerUpdatePhoto401Errors;
};

export type TaskAnswerUpdatePhotoBody = {
	/** photo */
	photo_id?: number | null;
};

export type TaskAnswerUpdate404Errors = { [key: string]: any };

export type TaskAnswerUpdate404 = {
	message?: string;
	errors?: TaskAnswerUpdate404Errors;
};

export type TaskAnswerUpdate403Errors = { [key: string]: any };

export type TaskAnswerUpdate403 = {
	message?: string;
	errors?: TaskAnswerUpdate403Errors;
};

export type TaskAnswerUpdate401Errors = { [key: string]: any };

export type TaskAnswerUpdate401 = {
	message?: string;
	errors?: TaskAnswerUpdate401Errors;
};

export type TaskAnswerUpdateBody = {
	/** Text containing answer text */
	answer?: unknown;
};

export type TaskAnswerCreate404Errors = { [key: string]: any };

export type TaskAnswerCreate404 = {
	message?: string;
	errors?: TaskAnswerCreate404Errors;
};

export type TaskAnswerCreate403Errors = { [key: string]: any };

export type TaskAnswerCreate403 = {
	message?: string;
	errors?: TaskAnswerCreate403Errors;
};

export type TaskAnswerCreate401Errors = { [key: string]: any };

export type TaskAnswerCreate401 = {
	message?: string;
	errors?: TaskAnswerCreate401Errors;
};

export type TaskAnswerCreateBody = {
	/** Text containing answer text */
	answer?: unknown;
};

export type TaskIndexByUser403Errors = { [key: string]: any };

export type TaskIndexByUser403 = {
	message?: string;
	errors?: TaskIndexByUser403Errors;
};

export type TaskIndexByUser401Errors = { [key: string]: any };

export type TaskIndexByUser401 = {
	message?: string;
	errors?: TaskIndexByUser401Errors;
};

export type TaskIndexByUser200 = {
	data?: Task[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type TaskDelete403Errors = { [key: string]: any };

export type TaskDelete403 = {
	message?: string;
	errors?: TaskDelete403Errors;
};

export type TaskDelete401Errors = { [key: string]: any };

export type TaskDelete401 = {
	message?: string;
	errors?: TaskDelete401Errors;
};

export type TaskDelete200 = {
	message?: string;
};

export type TaskUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type TaskUpdate403Errors = { [key: string]: any };

export type TaskUpdate403 = {
	message?: string;
	errors?: TaskUpdate403Errors;
};

export type TaskUpdate401Errors = { [key: string]: any };

export type TaskUpdate401 = {
	message?: string;
	errors?: TaskUpdate401Errors;
};

export type TaskUpdateBody = {
	/** Show on the day number of customer's course */
	day_number?: number;
	category?: TaskCategory;
	/** page id */
	page_id?: number | null;
};

export type TaskShow404Errors = { [key: string]: any };

export type TaskShow404 = {
	message?: string;
	errors?: TaskShow404Errors;
};

export type TaskShow401Errors = { [key: string]: any };

export type TaskShow401 = {
	message?: string;
	errors?: TaskShow401Errors;
};

export type TaskCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type TaskCreate403Errors = { [key: string]: any };

export type TaskCreate403 = {
	message?: string;
	errors?: TaskCreate403Errors;
};

export type TaskCreate401Errors = { [key: string]: any };

export type TaskCreate401 = {
	message?: string;
	errors?: TaskCreate401Errors;
};

export type TaskCreateBody = {
	/** Show on the day number of customer's course */
	day_number?: number;
	category?: TaskCategory;
	/** page id */
	page_id?: number | null;
};

export type TaskIndex403Errors = { [key: string]: any };

export type TaskIndex403 = {
	message?: string;
	errors?: TaskIndex403Errors;
};

export type TaskIndex401Errors = { [key: string]: any };

export type TaskIndex401 = {
	message?: string;
	errors?: TaskIndex401Errors;
};

export type TaskIndex200 = {
	data?: Task[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type TaskIndexParams = { category?: TaskCategory };

export type TagIndex403Errors = { [key: string]: any };

export type TagIndex403 = {
	message?: string;
	errors?: TagIndex403Errors;
};

export type TagIndex401Errors = { [key: string]: any };

export type TagIndex401 = {
	message?: string;
	errors?: TagIndex401Errors;
};

export type TagIndex200 = {
	data?: Tag[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type ReviewLatest404Errors = { [key: string]: any };

export type ReviewLatest404 = {
	message?: string;
	errors?: ReviewLatest404Errors;
};

export type ReviewLatest401Errors = { [key: string]: any };

export type ReviewLatest401 = {
	message?: string;
	errors?: ReviewLatest401Errors;
};

export type ReviewDelete403Errors = { [key: string]: any };

export type ReviewDelete403 = {
	message?: string;
	errors?: ReviewDelete403Errors;
};

export type ReviewDelete401Errors = { [key: string]: any };

export type ReviewDelete401 = {
	message?: string;
	errors?: ReviewDelete401Errors;
};

export type ReviewDelete200 = {
	message?: string;
};

export type ReviewUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type ReviewUpdate403Errors = { [key: string]: any };

export type ReviewUpdate403 = {
	message?: string;
	errors?: ReviewUpdate403Errors;
};

export type ReviewUpdate401Errors = { [key: string]: any };

export type ReviewUpdate401 = {
	message?: string;
	errors?: ReviewUpdate401Errors;
};

export type ReviewUpdateBody = {
	/** The starting point for the review period */
	start_date?: string;
	/** The end point for the review period */
	end_date?: string;
	message?: string;
};

export type ReviewShow404Errors = { [key: string]: any };

export type ReviewShow404 = {
	message?: string;
	errors?: ReviewShow404Errors;
};

export type ReviewShow401Errors = { [key: string]: any };

export type ReviewShow401 = {
	message?: string;
	errors?: ReviewShow401Errors;
};

export type ReviewCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type ReviewCreate403Errors = { [key: string]: any };

export type ReviewCreate403 = {
	message?: string;
	errors?: ReviewCreate403Errors;
};

export type ReviewCreate401Errors = { [key: string]: any };

export type ReviewCreate401 = {
	message?: string;
	errors?: ReviewCreate401Errors;
};

export type ReviewCreateBody = {
	/** The starting point for the review period */
	start_date?: string;
	/** The end point for the review period */
	end_date?: string;
	message?: string;
};

export type ReviewIndex422 = {
	message?: string;
	errors?: FieldError[];
};

export type ReviewIndex404Errors = { [key: string]: any };

export type ReviewIndex404 = {
	message?: string;
	errors?: ReviewIndex404Errors;
};

export type ReviewIndex403Errors = { [key: string]: any };

export type ReviewIndex403 = {
	message?: string;
	errors?: ReviewIndex403Errors;
};

export type ReviewIndex401Errors = { [key: string]: any };

export type ReviewIndex401 = {
	message?: string;
	errors?: ReviewIndex401Errors;
};

export type ReviewIndex200 = {
	data?: Review[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type ReviewIndexParams = {
	status?: ReviewStatus;
	sort?: string;
	items?: number;
};

export type ProfileLatest404Errors = { [key: string]: any };

export type ProfileLatest404 = {
	message?: string;
	errors?: ProfileLatest404Errors;
};

export type ProfileLatest403Errors = { [key: string]: any };

export type ProfileLatest403 = {
	message?: string;
	errors?: ProfileLatest403Errors;
};

export type ProfileLatest401Errors = { [key: string]: any };

export type ProfileLatest401 = {
	message?: string;
	errors?: ProfileLatest401Errors;
};

export type ProfileDelete404Errors = { [key: string]: any };

export type ProfileDelete404 = {
	message?: string;
	errors?: ProfileDelete404Errors;
};

export type ProfileDelete403Errors = { [key: string]: any };

export type ProfileDelete403 = {
	message?: string;
	errors?: ProfileDelete403Errors;
};

export type ProfileDelete401Errors = { [key: string]: any };

export type ProfileDelete401 = {
	message?: string;
	errors?: ProfileDelete401Errors;
};

export type ProfileDelete200 = {
	message?: string;
};

export type ProfileCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type ProfileCreate403Errors = { [key: string]: any };

export type ProfileCreate403 = {
	message?: string;
	errors?: ProfileCreate403Errors;
};

export type ProfileCreate401Errors = { [key: string]: any };

export type ProfileCreate401 = {
	message?: string;
	errors?: ProfileCreate401Errors;
};

export type ProfileCreateBody = {
	gender?: Gender;
	/** Date of birth */
	date_of_birth?: string;
	/** 3 digit code */
	postal_code?: string | null;
	/** Weight in kg */
	weight_kg?: number;
	/** Height in cm */
	height_cm?: number;
	/** Any more targets ? */
	target_note?: string | null;
	/** Further location information */
	location_note?: string | null;
	/** How much do you move ? */
	activity?: string | null;
	/** What is your job ? */
	occupation?: string | null;
	/** Where do you excel ? */
	strengths?: string | null;
	/** Something interesting about you */
	fun_facts?: string | null;
	/** Any health issues ? */
	other_health_info?: string | null;
	/** Any big milestones ? */
	accomplishments?: string | null;
	/** Have you done this before ? */
	previous_experience?: string | null;
	tag_ids?: number[];
};

export type ProfileIndex403Errors = { [key: string]: any };

export type ProfileIndex403 = {
	message?: string;
	errors?: ProfileIndex403Errors;
};

export type ProfileIndex401Errors = { [key: string]: any };

export type ProfileIndex401 = {
	message?: string;
	errors?: ProfileIndex401Errors;
};

export type ProfileIndex200 = {
	data?: Profile[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type PeriodDelete404Errors = { [key: string]: any };

export type PeriodDelete404 = {
	message?: string;
	errors?: PeriodDelete404Errors;
};

export type PeriodDelete403Errors = { [key: string]: any };

export type PeriodDelete403 = {
	message?: string;
	errors?: PeriodDelete403Errors;
};

export type PeriodDelete401Errors = { [key: string]: any };

export type PeriodDelete401 = {
	message?: string;
	errors?: PeriodDelete401Errors;
};

export type PeriodDelete200 = {
	message?: string;
};

export type PeriodUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PeriodUpdate404Errors = { [key: string]: any };

export type PeriodUpdate404 = {
	message?: string;
	errors?: PeriodUpdate404Errors;
};

export type PeriodUpdate403Errors = { [key: string]: any };

export type PeriodUpdate403 = {
	message?: string;
	errors?: PeriodUpdate403Errors;
};

export type PeriodUpdate401Errors = { [key: string]: any };

export type PeriodUpdate401 = {
	message?: string;
	errors?: PeriodUpdate401Errors;
};

export type PeriodUpdateBody = {
	/** Start date of period */
	start_date?: string;
	/** End date of period */
	end_date?: string;
	/** The starting day for the period */
	day_number?: number;
};

export type PeriodCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PeriodCreate403Errors = { [key: string]: any };

export type PeriodCreate403 = {
	message?: string;
	errors?: PeriodCreate403Errors;
};

export type PeriodCreate401Errors = { [key: string]: any };

export type PeriodCreate401 = {
	message?: string;
	errors?: PeriodCreate401Errors;
};

export type PeriodCreateBody = {
	/** Start date of period */
	start_date?: string;
	/** End date of period */
	end_date?: string;
	/** The starting day for the period */
	day_number?: number;
};

export type PeriodIndex403Errors = { [key: string]: any };

export type PeriodIndex403 = {
	message?: string;
	errors?: PeriodIndex403Errors;
};

export type PeriodIndex401Errors = { [key: string]: any };

export type PeriodIndex401 = {
	message?: string;
	errors?: PeriodIndex401Errors;
};

export type PeriodIndex200 = {
	data?: Period[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type PasswordTokenUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PasswordTokenUpdate404Errors = { [key: string]: any };

export type PasswordTokenUpdate404 = {
	message?: string;
	errors?: PasswordTokenUpdate404Errors;
};

export type PasswordTokenUpdateBody = {
	email?: string;
	code?: string;
	password?: string | null;
	password_confirmation?: string | null;
	device_name?: DeviceName;
};

export type PasswordTokenVerify422 = {
	message?: string;
	errors?: FieldError[];
};

export type PasswordTokenVerify404Errors = { [key: string]: any };

export type PasswordTokenVerify404 = {
	message?: string;
	errors?: PasswordTokenVerify404Errors;
};

export type PasswordTokenVerifyBody = {
	email?: string;
	code?: string;
};

export type PasswordTokenCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PasswordTokenCreateBody = {
	email?: string;
};

export type PageItemDelete403Errors = { [key: string]: any };

export type PageItemDelete403 = {
	message?: string;
	errors?: PageItemDelete403Errors;
};

export type PageItemDelete401Errors = { [key: string]: any };

export type PageItemDelete401 = {
	message?: string;
	errors?: PageItemDelete401Errors;
};

export type PageItemDelete200 = {
	message?: string;
};

export type PageItemUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PageItemUpdate403Errors = { [key: string]: any };

export type PageItemUpdate403 = {
	message?: string;
	errors?: PageItemUpdate403Errors;
};

export type PageItemUpdate401Errors = { [key: string]: any };

export type PageItemUpdate401 = {
	message?: string;
	errors?: PageItemUpdate401Errors;
};

export type PageItemUpdateBody = {
	/** Id of related document */
	document_id?: number | null;
	/** Text content */
	content?: string;
	status?: PageStatus;
	/** Sorting order */
	ord?: number;
};

export type PageItemCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PageItemCreate403Errors = { [key: string]: any };

export type PageItemCreate403 = {
	message?: string;
	errors?: PageItemCreate403Errors;
};

export type PageItemCreate401Errors = { [key: string]: any };

export type PageItemCreate401 = {
	message?: string;
	errors?: PageItemCreate401Errors;
};

export type PageItemCreateBody = {
	/** Id of related document */
	document_id?: number | null;
	/** Text content */
	content?: string;
	status?: PageStatus;
	/** Sorting order */
	ord?: number;
};

export type PageDelete403Errors = { [key: string]: any };

export type PageDelete403 = {
	message?: string;
	errors?: PageDelete403Errors;
};

export type PageDelete401Errors = { [key: string]: any };

export type PageDelete401 = {
	message?: string;
	errors?: PageDelete401Errors;
};

export type PageDelete200 = {
	message?: string;
};

export type PageUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PageUpdate403Errors = { [key: string]: any };

export type PageUpdate403 = {
	message?: string;
	errors?: PageUpdate403Errors;
};

export type PageUpdate401Errors = { [key: string]: any };

export type PageUpdate401 = {
	message?: string;
	errors?: PageUpdate401Errors;
};

export type PageUpdateBody = {
	/** page title */
	title?: string;
	/** When should the page be visible */
	publish_date?: string;
	category?: PageCategory;
	status?: PageStatus;
	/** Sorting order */
	ord?: number;
};

export type PageShow404Errors = { [key: string]: any };

export type PageShow404 = {
	message?: string;
	errors?: PageShow404Errors;
};

export type PageShow401Errors = { [key: string]: any };

export type PageShow401 = {
	message?: string;
	errors?: PageShow401Errors;
};

export type PageCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type PageCreate403Errors = { [key: string]: any };

export type PageCreate403 = {
	message?: string;
	errors?: PageCreate403Errors;
};

export type PageCreate401Errors = { [key: string]: any };

export type PageCreate401 = {
	message?: string;
	errors?: PageCreate401Errors;
};

export type PageCreateBody = {
	/** page title */
	title?: string;
	/** When should the page be visible */
	publish_date?: string;
	category?: PageCategory;
	status?: PageStatus;
	/** Sorting order */
	ord?: number;
};

export type PageIndex404Errors = { [key: string]: any };

export type PageIndex404 = {
	message?: string;
	errors?: PageIndex404Errors;
};

export type PageIndex401Errors = { [key: string]: any };

export type PageIndex401 = {
	message?: string;
	errors?: PageIndex401Errors;
};

export type PageIndex200 = {
	data?: Page[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type PageIndexParams = { category?: PageCategory };

export type NotificationUserRead404Errors = { [key: string]: any };

export type NotificationUserRead404 = {
	message?: string;
	errors?: NotificationUserRead404Errors;
};

export type NotificationUserRead403Errors = { [key: string]: any };

export type NotificationUserRead403 = {
	message?: string;
	errors?: NotificationUserRead403Errors;
};

export type NotificationUserRead401Errors = { [key: string]: any };

export type NotificationUserRead401 = {
	message?: string;
	errors?: NotificationUserRead401Errors;
};

export type NotificationUserRead200 = {
	message?: string;
};

export type NotificationUserShow404Errors = { [key: string]: any };

export type NotificationUserShow404 = {
	message?: string;
	errors?: NotificationUserShow404Errors;
};

export type NotificationUserShow401Errors = { [key: string]: any };

export type NotificationUserShow401 = {
	message?: string;
	errors?: NotificationUserShow401Errors;
};

export type NotificationUserIndex404Errors = { [key: string]: any };

export type NotificationUserIndex404 = {
	message?: string;
	errors?: NotificationUserIndex404Errors;
};

export type NotificationUserIndex403Errors = { [key: string]: any };

export type NotificationUserIndex403 = {
	message?: string;
	errors?: NotificationUserIndex403Errors;
};

export type NotificationUserIndex401Errors = { [key: string]: any };

export type NotificationUserIndex401 = {
	message?: string;
	errors?: NotificationUserIndex401Errors;
};

export type NotificationUserIndex200 = {
	data?: Notification[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type NotificationUserIndexParams = { task_category?: TaskCategory };

export type NotificationSend422 = {
	message?: string;
	errors?: FieldError[];
};

export type NotificationSend404Errors = { [key: string]: any };

export type NotificationSend404 = {
	message?: string;
	errors?: NotificationSend404Errors;
};

export type NotificationSend403Errors = { [key: string]: any };

export type NotificationSend403 = {
	message?: string;
	errors?: NotificationSend403Errors;
};

export type NotificationSend401Errors = { [key: string]: any };

export type NotificationSend401 = {
	message?: string;
	errors?: NotificationSend401Errors;
};

export type NotificationSendBody = {
	user_ids?: number[];
	/** Also send message to firebase cloud service ? */
	use_firebase?: number;
};

export type NotificationSchedule422 = {
	message?: string;
	errors?: FieldError[];
};

export type NotificationSchedule404Errors = { [key: string]: any };

export type NotificationSchedule404 = {
	message?: string;
	errors?: NotificationSchedule404Errors;
};

export type NotificationSchedule403Errors = { [key: string]: any };

export type NotificationSchedule403 = {
	message?: string;
	errors?: NotificationSchedule403Errors;
};

export type NotificationSchedule401Errors = { [key: string]: any };

export type NotificationSchedule401 = {
	message?: string;
	errors?: NotificationSchedule401Errors;
};

export type NotificationScheduleBody = {
	/** The day number for the course */
	day_number?: number;
	task_category?: TaskCategory;
	/** Also send message to firebase cloud service ? */
	use_firebase?: number;
};

export type NotificationDelete404Errors = { [key: string]: any };

export type NotificationDelete404 = {
	message?: string;
	errors?: NotificationDelete404Errors;
};

export type NotificationDelete403Errors = { [key: string]: any };

export type NotificationDelete403 = {
	message?: string;
	errors?: NotificationDelete403Errors;
};

export type NotificationDelete401Errors = { [key: string]: any };

export type NotificationDelete401 = {
	message?: string;
	errors?: NotificationDelete401Errors;
};

export type NotificationDelete200 = {
	message?: string;
};

export type NotificationUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type NotificationUpdate404Errors = { [key: string]: any };

export type NotificationUpdate404 = {
	message?: string;
	errors?: NotificationUpdate404Errors;
};

export type NotificationUpdate403Errors = { [key: string]: any };

export type NotificationUpdate403 = {
	message?: string;
	errors?: NotificationUpdate403Errors;
};

export type NotificationUpdate401Errors = { [key: string]: any };

export type NotificationUpdate401 = {
	message?: string;
	errors?: NotificationUpdate401Errors;
};

export type NotificationUpdateBody = {
	/** Notification title */
	title?: string;
	/** Notification message */
	message?: string;
};

export type NotificationShow404Errors = { [key: string]: any };

export type NotificationShow404 = {
	message?: string;
	errors?: NotificationShow404Errors;
};

export type NotificationShow401Errors = { [key: string]: any };

export type NotificationShow401 = {
	message?: string;
	errors?: NotificationShow401Errors;
};

export type NotificationCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type NotificationCreate403Errors = { [key: string]: any };

export type NotificationCreate403 = {
	message?: string;
	errors?: NotificationCreate403Errors;
};

export type NotificationCreate401Errors = { [key: string]: any };

export type NotificationCreate401 = {
	message?: string;
	errors?: NotificationCreate401Errors;
};

export type NotificationCreateBody = {
	/** Notification title */
	title?: string;
	/** Notification message */
	message?: string;
};

export type NotificationIndex404Errors = { [key: string]: any };

export type NotificationIndex404 = {
	message?: string;
	errors?: NotificationIndex404Errors;
};

export type NotificationIndex403Errors = { [key: string]: any };

export type NotificationIndex403 = {
	message?: string;
	errors?: NotificationIndex403Errors;
};

export type NotificationIndex401Errors = { [key: string]: any };

export type NotificationIndex401 = {
	message?: string;
	errors?: NotificationIndex401Errors;
};

export type NotificationIndex200 = {
	data?: Notification[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type NotificationIndexParams = { task_category?: TaskCategory };

export type MeasurementUpdatePhoto404Errors = { [key: string]: any };

export type MeasurementUpdatePhoto404 = {
	message?: string;
	errors?: MeasurementUpdatePhoto404Errors;
};

export type MeasurementUpdatePhoto403Errors = { [key: string]: any };

export type MeasurementUpdatePhoto403 = {
	message?: string;
	errors?: MeasurementUpdatePhoto403Errors;
};

export type MeasurementUpdatePhoto401Errors = { [key: string]: any };

export type MeasurementUpdatePhoto401 = {
	message?: string;
	errors?: MeasurementUpdatePhoto401Errors;
};

export type MeasurementUpdatePhotoBody = {
	/** photo */
	photo_id?: number | null;
};

export type MeasurementUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type MeasurementUpdate403Errors = { [key: string]: any };

export type MeasurementUpdate403 = {
	message?: string;
	errors?: MeasurementUpdate403Errors;
};

export type MeasurementUpdate401Errors = { [key: string]: any };

export type MeasurementUpdate401 = {
	message?: string;
	errors?: MeasurementUpdate401Errors;
};

export type MeasurementUpdateBody = {
	/** Weight in kg */
	weight_kg?: number | null;
	/** Chest in cm */
	chest_cm?: number | null;
	/** Stomach in cm */
	stomach_cm?: number | null;
	/** Upper arm left in cm */
	upper_arm_left_cm?: number | null;
	/** Upper arm right in cm */
	upper_arm_right_cm?: number | null;
	/** Hips in cm */
	hips_cm?: number | null;
	/** Thigh left cm */
	thigh_left_cm?: number | null;
	/** Thigh right cm */
	thigh_right_cm?: number | null;
};

export type MeasurementCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type MeasurementCreate403Errors = { [key: string]: any };

export type MeasurementCreate403 = {
	message?: string;
	errors?: MeasurementCreate403Errors;
};

export type MeasurementCreate401Errors = { [key: string]: any };

export type MeasurementCreate401 = {
	message?: string;
	errors?: MeasurementCreate401Errors;
};

export type MeasurementCreateBody = {
	/** Date Logged. Time is stripped */
	log_date?: string;
	/** Weight in kg */
	weight_kg?: number | null;
	/** Chest in cm */
	chest_cm?: number | null;
	/** Stomach in cm */
	stomach_cm?: number | null;
	/** Upper arm left in cm */
	upper_arm_left_cm?: number | null;
	/** Upper arm right in cm */
	upper_arm_right_cm?: number | null;
	/** Hips in cm */
	hips_cm?: number | null;
	/** Thigh left cm */
	thigh_left_cm?: number | null;
	/** Thigh right cm */
	thigh_right_cm?: number | null;
};

export type MeasurementIndex422 = {
	message?: string;
	errors?: FieldError[];
};

export type MeasurementIndex403Errors = { [key: string]: any };

export type MeasurementIndex403 = {
	message?: string;
	errors?: MeasurementIndex403Errors;
};

export type MeasurementIndex401Errors = { [key: string]: any };

export type MeasurementIndex401 = {
	message?: string;
	errors?: MeasurementIndex401Errors;
};

export type MeasurementIndex200 = {
	data?: Measurement[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type MeasurementIndexParams = {
	date_from?: string;
	date_to?: string;
	sort?: string;
};

export type GoalLatest404Errors = { [key: string]: any };

export type GoalLatest404 = {
	message?: string;
	errors?: GoalLatest404Errors;
};

export type GoalLatest403Errors = { [key: string]: any };

export type GoalLatest403 = {
	message?: string;
	errors?: GoalLatest403Errors;
};

export type GoalLatest401Errors = { [key: string]: any };

export type GoalLatest401 = {
	message?: string;
	errors?: GoalLatest401Errors;
};

export type GoalCreate404Errors = { [key: string]: any };

export type GoalCreate404 = {
	message?: string;
	errors?: GoalCreate404Errors;
};

export type GoalCreate403Errors = { [key: string]: any };

export type GoalCreate403 = {
	message?: string;
	errors?: GoalCreate403Errors;
};

export type GoalCreate401Errors = { [key: string]: any };

export type GoalCreate401 = {
	message?: string;
	errors?: GoalCreate401Errors;
};

export type GoalCreateBody = {
	/** Start date for goals */
	start_date?: string;
	/** Carbs in grams */
	carbs_grams?: number | null;
	/** Protein in grams */
	protein_grams?: number | null;
	/** Fat in grams */
	fat_grams?: number | null;
	/** Fibers in grams */
	fiber_grams?: number | null;
};

export type DocumentEmbedVideo422 = {
	message?: string;
	errors?: FieldError[];
};

export type DocumentEmbedVideo403Errors = { [key: string]: any };

export type DocumentEmbedVideo403 = {
	message?: string;
	errors?: DocumentEmbedVideo403Errors;
};

export type DocumentEmbedVideo401Errors = { [key: string]: any };

export type DocumentEmbedVideo401 = {
	message?: string;
	errors?: DocumentEmbedVideo401Errors;
};

export type DocumentEmbedVideoBody = {
	/** Document name */
	name?: string;
	/** Video URL */
	url?: string;
};

export type DocumentUploadFile422 = {
	message?: string;
	errors?: FieldError[];
};

export type DocumentUploadFile403Errors = { [key: string]: any };

export type DocumentUploadFile403 = {
	message?: string;
	errors?: DocumentUploadFile403Errors;
};

export type DocumentUploadFile401Errors = { [key: string]: any };

export type DocumentUploadFile401 = {
	message?: string;
	errors?: DocumentUploadFile401Errors;
};

export type DocumentUploadFileBody = {
	/** File to upload */
	file: Blob;
	/** Document name */
	name: string;
	access: DocumentAccess;
	/** Owner user ID */
	owner_id?: number;
};

export type DiaryCommentRead422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiaryCommentRead404Errors = { [key: string]: any };

export type DiaryCommentRead404 = {
	message?: string;
	errors?: DiaryCommentRead404Errors;
};

export type DiaryCommentRead403Errors = { [key: string]: any };

export type DiaryCommentRead403 = {
	message?: string;
	errors?: DiaryCommentRead403Errors;
};

export type DiaryCommentRead401Errors = { [key: string]: any };

export type DiaryCommentRead401 = {
	message?: string;
	errors?: DiaryCommentRead401Errors;
};

export type DiaryCommentCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiaryCommentCreate404Errors = { [key: string]: any };

export type DiaryCommentCreate404 = {
	message?: string;
	errors?: DiaryCommentCreate404Errors;
};

export type DiaryCommentCreate403Errors = { [key: string]: any };

export type DiaryCommentCreate403 = {
	message?: string;
	errors?: DiaryCommentCreate403Errors;
};

export type DiaryCommentCreate401Errors = { [key: string]: any };

export type DiaryCommentCreate401 = {
	message?: string;
	errors?: DiaryCommentCreate401Errors;
};

export type DiaryCommentCreateBody = {
	/** Optional field name being referenced */
	resource_field?: string | null;
	category?: CommentCategory;
	/** The message body */
	message?: string | null;
};

export type DiaryReview422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiaryReview403Errors = { [key: string]: any };

export type DiaryReview403 = {
	message?: string;
	errors?: DiaryReview403Errors;
};

export type DiaryReview401Errors = { [key: string]: any };

export type DiaryReview401 = {
	message?: string;
	errors?: DiaryReview401Errors;
};

export type DiarySubmit422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiarySubmit403Errors = { [key: string]: any };

export type DiarySubmit403 = {
	message?: string;
	errors?: DiarySubmit403Errors;
};

export type DiarySubmit401Errors = { [key: string]: any };

export type DiarySubmit401 = {
	message?: string;
	errors?: DiarySubmit401Errors;
};

export type DiaryUpdate422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiaryUpdate403Errors = { [key: string]: any };

export type DiaryUpdate403 = {
	message?: string;
	errors?: DiaryUpdate403Errors;
};

export type DiaryUpdate401Errors = { [key: string]: any };

export type DiaryUpdate401 = {
	message?: string;
	errors?: DiaryUpdate401Errors;
};

export type DiaryUpdateBody = {
	/** Hours slept */
	sleep_hours?: number | null;
	/** Carbs in grams */
	carbs_grams?: number | null;
	/** Protein in grams */
	protein_grams?: number | null;
	/** Fat in grams */
	fat_grams?: number | null;
	/** Fibers in grams */
	fiber_grams?: number | null;
	/** Water in liters */
	water_liters?: number | null;
	/** Took vitamins ? */
	took_vitamins?: number | null;
	/** Hunger scale of 0-2 */
	was_hungry?: number | null;
	/** Food quality scale of 1-10 */
	food_quality?: number | null;
	/** Energy scale of 1-10 */
	energy?: number | null;
	/** Exercised ? */
	did_exercise_with_high_pulse?: number | null;
	/** Was its a low heart rate exercise ? */
	did_exercise_with_low_pulse?: number;
	/** Mood scale of 0-3 */
	mood?: number | null;
	/** Customer notes */
	note?: string | null;
};

export type DiaryCreate422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiaryCreate403Errors = { [key: string]: any };

export type DiaryCreate403 = {
	message?: string;
	errors?: DiaryCreate403Errors;
};

export type DiaryCreate401Errors = { [key: string]: any };

export type DiaryCreate401 = {
	message?: string;
	errors?: DiaryCreate401Errors;
};

export type DiaryCreateBody = {
	/** Date Logged. Time is stripped */
	log_date?: string;
	/** Hours slept */
	sleep_hours?: number | null;
	/** Carbs in grams */
	carbs_grams?: number | null;
	/** Protein in grams */
	protein_grams?: number | null;
	/** Fat in grams */
	fat_grams?: number | null;
	/** Fibers in grams */
	fiber_grams?: number | null;
	/** Water in liters */
	water_liters?: number | null;
	/** Took vitamins ? */
	took_vitamins?: number | null;
	/** Hunger scale of 0-2 */
	was_hungry?: number | null;
	/** Food quality scale of 1-10 */
	food_quality?: number | null;
	/** Energy scale of 1-10 */
	energy?: number | null;
	/** Exercised ? */
	did_exercise_with_high_pulse?: number | null;
	/** Was its a low heart rate exercise ? */
	did_exercise_with_low_pulse?: number;
	/** Mood scale of 0-3 */
	mood?: number | null;
	/** Customer notes */
	note?: string | null;
};

export type DiaryIndex422 = {
	message?: string;
	errors?: FieldError[];
};

export type DiaryIndex403Errors = { [key: string]: any };

export type DiaryIndex403 = {
	message?: string;
	errors?: DiaryIndex403Errors;
};

export type DiaryIndex401Errors = { [key: string]: any };

export type DiaryIndex401 = {
	message?: string;
	errors?: DiaryIndex401Errors;
};

export type DiaryIndex200 = {
	data?: Diary[];
	links?: PaginationLinks;
	meta?: PaginationMeta;
};

export type DiaryIndexParams = {
	date_from?: string;
	date_to?: string;
	sort?: string;
};

export type CourseCurrent404Errors = { [key: string]: any };

export type CourseCurrent404 = {
	message?: string;
	errors?: CourseCurrent404Errors;
};

export type CourseCurrent403Errors = { [key: string]: any };

export type CourseCurrent403 = {
	message?: string;
	errors?: CourseCurrent403Errors;
};

export type CourseCurrent401Errors = { [key: string]: any };

export type CourseCurrent401 = {
	message?: string;
	errors?: CourseCurrent401Errors;
};

export type AuthLogout401Errors = { [key: string]: any };

export type AuthLogout401 = {
	message?: string;
	errors?: AuthLogout401Errors;
};

export type AuthLogout200 = {
	message?: string;
};

export type AuthLogin400 = {
	message?: string;
};

export type AuthLoginBody = {
	email: string;
	password: string;
	device_name: DeviceName;
};

export type UserAllOf = {
	/** ID */
	id?: number;
	/** Name of user */
	name?: string;
	/** User email address */
	email?: string;
	/** Push token */
	push_token?: string | null;
	/** User notes */
	notes?: string | null;
	/** Verification date for user email address */
	email_verified_at?: string | null;
	role?: Role;
	status?: UserStatus;
	/** Last login date */
	login_date?: string | null;
	/** Photo id */
	photo_id?: number | null;
	/** Team id */
	team_id?: number | null;
	/** Spouse */
	spouse_id?: number | null;
	/** Profile count */
	profile_count?: number | null;
	photo?: Document;
};

/**
 * User model
 */
export type User = BaseModel & UserAllOf;

/**
 * UserLogin model
 */
export interface UserLogin {
	data?: User;
	/** Access Token */
	token?: string;
}

export type TeamAllOf = {
	id?: number;
	/** Name of team */
	name?: string;
	/** Further information */
	description?: string | null;
	users?: User[];
};

/**
 * Team
 */
export type Team = BaseModel & TeamAllOf;

export type TaskAllOf = {
	id?: number;
	/** Show on the day number of customer's course */
	day_number?: number;
	category?: TaskCategory;
	page_id?: number;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
	answers?: Answer[];
	page?: Page;
};

/**
 * Tasks created by operators/admins
 */
export type Task = BaseModel & TaskAllOf;

export type TagResourceAllOf = {
	id?: number;
	resource_name?: ResourceName;
	resource_id?: number;
	tag_id?: number;
	created_by?: number;
};

/**
 * TagResource
 */
export type TagResource = BaseModel & TagResourceAllOf;

export type TagAllOf = {
	id?: number;
	/** Name of tag */
	name?: string;
	/** URL friendly name */
	slug?: string;
	category?: TagCategory;
	/** Further information */
	description?: string | null;
};

/**
 * Tag
 */
export type Tag = BaseModel & TagAllOf;

/**
 * ReviewStatistics
 */
export interface ReviewStatistics {
	/** Average water consumed in liters */
	water_liters: number;
	/** Average hours slept */
	sleep_hours: number;
	/** Average grade. Null if no diaries are found for specified period */
	grade?: number | null;
}

export type ReviewAllOf = {
	id?: number;
	user_id?: number;
	goal_id?: number | null;
	resource_name?: ResourceName;
	/** The starting point for the review period */
	start_date?: string;
	/** The end point for the review period */
	end_date?: string;
	message?: string;
	status?: ReviewStatus;
	created_by?: number;
	modified_by?: number | null;
	statistics?: ReviewStatistics;
};

/**
 * Review
 */
export type Review = BaseModel & ReviewAllOf;

export type ProfileAllOf = {
	id?: number;
	/** Start date */
	start_date?: string;
	gender?: Gender;
	/** Date of birth */
	date_of_birth?: string;
	/** 3 digit code */
	postal_code?: string;
	/** Height in cm */
	height_cm?: number;
	/** Any more targets ? */
	target_note?: string;
	/** Further location info */
	location_note?: string;
	/** How much do you move ? */
	activity?: string;
	/** What is your job ? */
	occupation?: string;
	/** Where do you excel ? */
	strengths?: string;
	/** Something interesting about you */
	fun_facts?: string;
	/** Any health issues ? */
	other_health_info?: string;
	/** Any big milestones ? */
	accomplishments?: string;
	/** Have you done this before ? */
	previous_experience?: string;
	/** Created by user ID */
	created_by?: number;
	measurement?: Measurement;
	tags?: Tag[];
};

/**
 * Customer profiles
 */
export type Profile = BaseModel & ProfileAllOf;

export type PostalCodeAllOf = {
	id?: number;
	/** Postal code */
	code?: string;
	/** Location */
	location?: string;
};

/**
 * PostalCode
 */
export type PostalCode = BaseModel & PostalCodeAllOf;

export type PeriodAllOf = {
	id?: number;
	user_id?: number;
	/** Start date */
	start_date?: string;
	/** End date */
	end_date?: string;
	/** Show on the day number of customer's course */
	day_number?: number;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
};

/**
 * Customer profiles
 */
export type Period = BaseModel & PeriodAllOf;

/**
 * PaginationMeta
 */
export interface PaginationMeta {
	/** Current page */
	current_page?: number;
	/** From */
	from?: number | null;
	/** Last page */
	last_page?: number;
	/** From */
	path?: string;
	/** Last page */
	per_page?: number;
	/** To */
	to?: number | null;
	/** Last page */
	total?: number;
}

/**
 * PaginationLinks
 */
export interface PaginationLinks {
	/** First */
	first?: string;
	/** Last */
	last?: string;
	/** Previous */
	prev?: string | null;
	/** Next */
	next?: string | null;
}

export type PageItemAllOf = {
	id?: number;
	page_id?: number;
	document_id?: number | null;
	/** Page content */
	content?: string | null;
	status?: PageStatus;
	/** Sorting order */
	ord?: number;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
	document?: Document;
};

/**
 * PageItem
 */
export type PageItem = BaseModel & PageItemAllOf;

export type PageAllOf = {
	id?: number;
	/** Page title */
	title?: string;
	/** URL friendly name */
	slug?: string;
	/** When should the page be visible */
	publish_date?: string;
	category?: PageCategory;
	status?: PageStatus;
	/** Sorting order */
	ord?: number;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
	items?: PageItem[];
};

/**
 * Page
 */
export type Page = BaseModel & PageAllOf;

export type NotificationUserAllOf = {
	id?: number;
	notification_id?: number;
	user_id?: number;
	/** When did the user read the notification ? */
	read_date?: string | null;
	user?: User;
};

/**
 * NotificationUser
 */
export type NotificationUser = BaseModel & NotificationUserAllOf;

export type NotificationAllOf = {
	id?: number;
	/** Message title */
	title?: string;
	/** Message body */
	message?: string;
	/** Show on the day number of customer's course */
	day_number?: number | null;
	task_category?: TaskCategory;
	status?: NotificationStatus;
	/** Also send message to firebase cloud service ? */
	use_firebase?: number;
	/** Date sent */
	sent_date?: string | null;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
	users?: NotificationUser[];
};

/**
 * Notification
 */
export type Notification = BaseModel & NotificationAllOf;

/**
 * Customer body measurements
 */
export type Measurement = BaseModel & MeasurementAllOf;

export type GoalAllOf = {
	id?: number;
	user_id?: number;
	profile_id?: number | null;
	/** Start date for goals */
	start_date?: string;
	/** Carbs in grams */
	carbs_grams?: number | null;
	/** Protein in grams */
	protein_grams?: number | null;
	/** Fat in grams */
	fat_grams?: number | null;
	/** Fibers in grams */
	fiber_grams?: number | null;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
};

/**
 * FieldError
 */
export interface FieldError {
	/** Field key */
	field?: string;
	/** Error messages */
	messages?: string[];
}

export type DocumentAllOf = {
	id?: number;
	/** User ID for document owner */
	owner_id?: number | null;
	/** The original name for the file */
	name?: string;
	/** The stored filename */
	filename?: string;
	/** Document URL */
	url?: string | null;
	/** Mime type of document */
	mime_type?: string | null;
	format?: DocumentFormat;
	access?: DocumentAccess;
	created_by?: number;
	modified_by?: number | null;
};

/**
 * Documents created by users
 */
export type Document = BaseModel & DocumentAllOf;

export type MeasurementAllOf = {
	id?: number;
	/** Date of log */
	log_date?: string;
	/** Weight in kg */
	weight_kg?: number;
	/** Chest in cm */
	chest_cm?: number | null;
	/** Stomach in cm */
	stomach_cm?: number | null;
	/** Upper arm left in cm */
	upper_arm_left_cm?: number | null;
	/** Upper arm right in cm */
	upper_arm_right_cm?: number | null;
	/** Hips cm */
	hips_cm?: number | null;
	/** Thigh left cm */
	thigh_left_cm?: number | null;
	/** Thigh right cm */
	thigh_right_cm?: number | null;
	photo_front_id?: number | null;
	photo_side_id?: number | null;
	created_by?: number;
	modified_by?: number | null;
	photo_front?: Document;
	photo_side?: Document;
};

/**
 * A string used when generating an access token
 */
export type DeviceName = string;

export type CourseAllOf = {
	/** Start date for goals */
	start_date?: string;
};

export type CommentAllOf = {
	id?: number;
	resource_name?: ResourceName;
	resource_id?: number;
	/** Field name being referenced */
	resource_field?: string | null;
	category?: CommentCategory;
	/** Has the comment been read by the recipient ? */
	is_read?: number;
	message?: string | null;
	created_by?: number;
};

/**
 * base model
 */
export interface BaseModel {
	/** Initial creation timestamp */
	created_at?: string;
	/** Last update timestamp */
	updated_at?: string | null;
}

/**
 * Goals set by operators for each customer
 */
export type Goal = BaseModel & GoalAllOf;

/**
 * Course
 */
export type Course = BaseModel & CourseAllOf;

/**
 * Comments and likes made by users in the system
 */
export type Comment = BaseModel & CommentAllOf;

export type DiaryAllOf = {
	id?: number;
	user_id?: number;
	/** Date of log */
	log_date?: string;
	status?: DiaryStatus;
	/** Hours slept */
	sleep_hours?: number | null;
	/** Carbs in grams */
	carbs_grams?: number | null;
	/** Protein in grams */
	protein_grams?: number | null;
	/** Fat in grams */
	fat_grams?: number | null;
	/** Fibers in grams */
	fiber_grams?: number | null;
	/** Water consumed in liters */
	water_liters?: number | null;
	/** Took vitamins */
	took_vitamins?: number | null;
	/** Hunger scale of 0-2 */
	was_hungry?: number | null;
	/** Hunger scale of 0-2 */
	food_quality?: number | null;
	/** Food quality scale of 1-10 */
	energy?: number | null;
	/** Was its a hight heart rate exercise ? */
	did_exercise_with_high_pulse?: number | null;
	/** Was its a low heart rate exercise ? */
	did_exercise_with_low_pulse?: number | null;
	/** Mood scale of 0-3 */
	mood?: number | null;
	/** Customer notes */
	note?: string | null;
	/** Grade */
	grade?: number | null;
	created_by?: number;
	modified_by?: number | null;
	comments?: Comment[];
};

/**
 * Customer diaries containing information on daily consumption, energy etc.
 */
export type Diary = BaseModel & DiaryAllOf;

export type AnswerAllOf = {
	id?: number;
	user_id?: number;
	task_id?: number;
	answer?: string | null;
	photo_id?: number | null;
	/** Created by user ID */
	created_by?: number;
	/** Last modified by user ID */
	modified_by?: number | null;
	photo?: Document;
};

/**
 * Customer answers to tasks given by operators/admins
 */
export type Answer = BaseModel & AnswerAllOf;

export type UserStatus = typeof UserStatus[keyof typeof UserStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserStatus = {
	login: 'login',
	profile: 'profile',
	goal: 'goal',
	period: 'period',
	active: 'active',
} as const;

export type TaskCategory = typeof TaskCategory[keyof typeof TaskCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskCategory = {
	individual: 'individual',
	couple: 'couple',
	both: 'both',
	none: 'none',
} as const;

export type TagCategory = typeof TagCategory[keyof typeof TagCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TagCategory = {
	target: 'target',
	diet: 'diet',
	specialCircumstance: 'specialCircumstance',
	itsConnection: 'itsConnection',
} as const;

export type Role = typeof Role[keyof typeof Role];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Role = {
	admin: 'admin',
	operator: 'operator',
	customer: 'customer',
	scheduler: 'scheduler',
} as const;

export type ReviewStatus = typeof ReviewStatus[keyof typeof ReviewStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewStatus = {
	new: 'new',
	viewed: 'viewed',
} as const;

export type ResourceName = typeof ResourceName[keyof typeof ResourceName];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ResourceName = {
	diary: 'diary',
	measurement: 'measurement',
	profile: 'profile',
} as const;

export type PageStatus = typeof PageStatus[keyof typeof PageStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PageStatus = {
	visible: 'visible',
	hidden: 'hidden',
} as const;

export type PageCategory = typeof PageCategory[keyof typeof PageCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PageCategory = {
	myGoals: 'myGoals',
	messenger: 'messenger',
	handbook: 'handbook',
	myFitnessPal: 'myFitnessPal',
	education: 'education',
	articles: 'articles',
	recipes: 'recipes',
	nutritionTables: 'nutritionTables',
	video: 'video',
	workoutProgram8Weeks: 'workoutProgram8Weeks',
	runningProgram8Weeks: 'runningProgram8Weeks',
	workoutProgram8WeeksMaster: 'workoutProgram8WeeksMaster',
	meditation: 'meditation',
	yoga: 'yoga',
	cooling: 'cooling',
	breathing: 'breathing',
	miscellaneous: 'miscellaneous',
	tasks: 'tasks',
	stretchesIngaBirna: 'stretchesIngaBirna',
} as const;

export type NotificationStatus =
	typeof NotificationStatus[keyof typeof NotificationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationStatus = {
	new: 'new',
	sent: 'sent',
	scheduled: 'scheduled',
} as const;

export type MeasurementPhotoAngle =
	typeof MeasurementPhotoAngle[keyof typeof MeasurementPhotoAngle];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeasurementPhotoAngle = {
	front: 'front',
	side: 'side',
} as const;

export type Gender = typeof Gender[keyof typeof Gender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
	female: 'female',
	male: 'male',
	other: 'other',
} as const;

export type DocumentFormat = typeof DocumentFormat[keyof typeof DocumentFormat];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentFormat = {
	vimeo: 'vimeo',
	file: 'file',
} as const;

export type DocumentAccess = typeof DocumentAccess[keyof typeof DocumentAccess];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentAccess = {
	public: 'public',
	restricted: 'restricted',
} as const;

export type DiaryStatus = typeof DiaryStatus[keyof typeof DiaryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiaryStatus = {
	drafted: 'drafted',
	submitted: 'submitted',
	reviewed: 'reviewed',
} as const;

export type CommentCategory =
	typeof CommentCategory[keyof typeof CommentCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentCategory = {
	text: 'text',
	like: 'like',
} as const;

export type AwaitedInput<T> = PromiseLike<T> | T;

export type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Login by email, password
 * @summary Sign in
 */
export const authLogin = <TData = AxiosResponse<UserLogin>>(
	authLoginBody: AuthLoginBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/auth/login`, authLoginBody, options);
};

/**
 * Log user out
 * @summary Log user out
 */
export const authLogout = <TData = AxiosResponse<AuthLogout200>>(
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/auth/logout`, undefined, options);
};

/**
 * Get the current course (or the next upcoming)
 * @summary Get the current course (or the next upcoming)
 */
export const courseCurrent = <TData = AxiosResponse<Course>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/courses/current`, options);
};

/**
 * List customer diaries
 * @summary List customer diaries
 */
export const diaryIndex = <TData = AxiosResponse<DiaryIndex200>>(
	user: number,
	params?: DiaryIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/diaries`, {
		params,
		...options,
	});
};

/**
 * Start a new diary entry
 * @summary Start a new diary entry
 */
export const diaryCreate = <TData = AxiosResponse<Diary>>(
	user: number,
	diaryCreateBody: DiaryCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/${user}/diaries`, diaryCreateBody, options);
};

/**
 * Update an existing diary entry
 * @summary Update an existing diary entry
 */
export const diaryUpdate = <TData = AxiosResponse<Diary>>(
	user: number,
	diary: number,
	diaryUpdateBody: DiaryUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(`/users/${user}/diaries/${diary}`, diaryUpdateBody, options);
};

/**
 * Submit a diary entry for review
 * @summary Submit a diary entry for review
 */
export const diarySubmit = <TData = AxiosResponse<Diary>>(
	user: number,
	diary: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/diaries/${diary}/submit`,
		undefined,
		options
	);
};

/**
 * Mark a diary entry as reviewed
 * @summary Mark a diary entry as reviewed
 */
export const diaryReview = <TData = AxiosResponse<Diary>>(
	user: number,
	diary: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/diaries/${diary}/review`,
		undefined,
		options
	);
};

/**
 * Comment on a diary entry
 * @summary Comment on a diary entry
 */
export const diaryCommentCreate = <TData = AxiosResponse<Comment>>(
	user: number,
	diary: number,
	diaryCommentCreateBody: DiaryCommentCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(
		`/users/${user}/diaries/${diary}/comments`,
		diaryCommentCreateBody,
		options
	);
};

/**
 * Mark a comment as read
 * @summary Mark a comment as read
 */
export const diaryCommentRead = <TData = AxiosResponse<Comment>>(
	user: number,
	diary: number,
	comment: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/diaries/${diary}/comments/${comment}/read`,
		undefined,
		options
	);
};

/**
 * Create a document using file upload
 * @summary Create a document using file upload
 */
export const documentUploadFile = <TData = AxiosResponse<Document>>(
	documentUploadFileBody: DocumentUploadFileBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	const formData = new FormData();
	formData.append('file', documentUploadFileBody.file);
	formData.append('name', documentUploadFileBody.name);
	formData.append('access', documentUploadFileBody.access);
	if (documentUploadFileBody.owner_id !== undefined) {
		formData.append('owner_id', documentUploadFileBody.owner_id.toString());
	}

	return axios.post(`/documents/upload-file`, formData, options);
};

/**
 * Create document using a video URL
 * @summary Create document using a video URL
 */
export const documentEmbedVideo = <TData = AxiosResponse<Document>>(
	documentEmbedVideoBody: DocumentEmbedVideoBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/documents/embed-video`, documentEmbedVideoBody, options);
};

/**
 * Create a new goals entry
 * @summary Create a new goals entry
 */
export const goalCreate = <TData = AxiosResponse<Goal>>(
	user: number,
	goalCreateBody: GoalCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/${user}/goals`, goalCreateBody, options);
};

/**
 * Get the latest goals for a user
 * @summary Get the latest goals for a user
 */
export const goalLatest = <TData = AxiosResponse<Goal>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/goals/latest`, options);
};

/**
 * List measurements
 * @summary List measurements
 */
export const measurementIndex = <TData = AxiosResponse<MeasurementIndex200>>(
	user: number,
	params?: MeasurementIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/measurements`, {
		params,
		...options,
	});
};

/**
 * Write a measurement log
 * @summary Write a measurement log
 */
export const measurementCreate = <TData = AxiosResponse<Measurement>>(
	user: number,
	measurementCreateBody: MeasurementCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(
		`/users/${user}/measurements`,
		measurementCreateBody,
		options
	);
};

/**
 * Update a measurement log
 * @summary Update a measurement log
 */
export const measurementUpdate = <TData = AxiosResponse<Measurement>>(
	user: number,
	measurement: number,
	measurementUpdateBody: MeasurementUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(
		`/users/${user}/measurements/${measurement}`,
		measurementUpdateBody,
		options
	);
};

/**
 * Update photo
 * @summary Update photo
 */
export const measurementUpdatePhoto = <TData = AxiosResponse<Measurement>>(
	user: number,
	measurement: number,
	angle: MeasurementPhotoAngle,
	measurementUpdatePhotoBody: MeasurementUpdatePhotoBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/measurements/${measurement}/photo/${angle}`,
		measurementUpdatePhotoBody,
		options
	);
};

/**
 * List all notifications without attached notifications users
 * @summary List all notifications
 */
export const notificationIndex = <TData = AxiosResponse<NotificationIndex200>>(
	params?: NotificationIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/notifications`, {
		params,
		...options,
	});
};

/**
 * Create a new basic notification with a title and a message
 * @summary Create a new notification
 */
export const notificationCreate = <TData = AxiosResponse<Notification>>(
	notificationCreateBody: NotificationCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/notifications`, notificationCreateBody, options);
};

/**
 * Get one notification including records for notification users
 * @summary Get one notification
 */
export const notificationShow = <TData = AxiosResponse<Notification>>(
	notification: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/notifications/${notification}`, options);
};

/**
 * Update a notification
 * @summary Update a notification's title and/or message
 */
export const notificationUpdate = <TData = AxiosResponse<Notification>>(
	notification: number,
	notificationUpdateBody: NotificationUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(
		`/notifications/${notification}`,
		notificationUpdateBody,
		options
	);
};

/**
 * Delete a notification
 * @summary Delete a notification
 */
export const notificationDelete = <
	TData = AxiosResponse<NotificationDelete200>
>(
	notification: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/notifications/${notification}`, options);
};

/**
 * This notification will be sent to users on the specified course day
 * @summary Schedule a notification
 */
export const notificationSchedule = <TData = AxiosResponse<Notification>>(
	notification: number,
	notificationScheduleBody: NotificationScheduleBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/notifications/${notification}/schedule`,
		notificationScheduleBody,
		options
	);
};

/**
 * Send a notification
 * @summary Send a notification to the users specified.
 */
export const notificationSend = <TData = AxiosResponse<Notification>>(
	notification: number,
	notificationSendBody: NotificationSendBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/notifications/${notification}/send`,
		notificationSendBody,
		options
	);
};

/**
 * List all notifications sent to the user specified.
 * @summary List all notifications by user
 */
export const notificationUserIndex = <
	TData = AxiosResponse<NotificationUserIndex200>
>(
	user: number,
	params?: NotificationUserIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/notifications`, {
		params,
		...options,
	});
};

/**
 * Get one notification by user
 * @summary Get one notification by user
 */
export const notificationUserShow = <TData = AxiosResponse<Notification>>(
	user: number,
	notification: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/notifications/${notification}`, options);
};

/**
 * Mark the notification as read for the user specified
 * @summary Read a notification
 */
export const notificationUserRead = <
	TData = AxiosResponse<NotificationUserRead200>
>(
	user: number,
	notification: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/notifications/${notification}/read`,
		undefined,
		options
	);
};

/**
 * Get all pages
 * @summary Get all pages
 */
export const pageIndex = <TData = AxiosResponse<PageIndex200>>(
	params?: PageIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/pages`, {
		params,
		...options,
	});
};

/**
 * Create a new page
 * @summary Create a new page
 */
export const pageCreate = <TData = AxiosResponse<Page>>(
	pageCreateBody: PageCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/pages`, pageCreateBody, options);
};

/**
 * Get one page
 * @summary Get one page
 */
export const pageShow = <TData = AxiosResponse<Page>>(
	page: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/pages/${page}`, options);
};

/**
 * Update an existing page
 * @summary Update an existing page
 */
export const pageUpdate = <TData = AxiosResponse<Page>>(
	page: number,
	pageUpdateBody: PageUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(`/pages/${page}`, pageUpdateBody, options);
};

/**
 * Delete a page
 * @summary Delete a page
 */
export const pageDelete = <TData = AxiosResponse<PageDelete200>>(
	page: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/pages/${page}`, options);
};

/**
 * Create a new page item
 * @summary Create a new page item
 */
export const pageItemCreate = <TData = AxiosResponse<PageItem>>(
	page: number,
	pageItemCreateBody: PageItemCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/pages/${page}/item`, pageItemCreateBody, options);
};

/**
 * Update a page item
 * @summary Update a page item
 */
export const pageItemUpdate = <TData = AxiosResponse<PageItem>>(
	page: number,
	item: number,
	pageItemUpdateBody: PageItemUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(`/pages/${page}/item/${item}`, pageItemUpdateBody, options);
};

/**
 * Delete a page item
 * @summary Delete a page item
 */
export const pageItemDelete = <TData = AxiosResponse<PageItemDelete200>>(
	page: number,
	item: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/pages/${page}/item/${item}`, options);
};

/**
 * Create a new 8-digit code to use for password recovery. Automatically sends an email to the customer
 * @summary Create a new password token
 */
export const passwordTokenCreate = <TData = AxiosResponse<void>>(
	passwordTokenCreateBody: PasswordTokenCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/password-tokens`, passwordTokenCreateBody, options);
};

/**
 * Verify a password token used for password recovery
 * @summary Verify a password token
 */
export const passwordTokenVerify = <TData = AxiosResponse<void>>(
	passwordTokenVerifyBody: PasswordTokenVerifyBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(
		`/users/password-tokens/verify`,
		passwordTokenVerifyBody,
		options
	);
};

/**
 * Update password using a password recovery token
 * @summary Update password using a password recovery token
 */
export const passwordTokenUpdate = <TData = AxiosResponse<UserLogin>>(
	passwordTokenUpdateBody: PasswordTokenUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(
		`/users/password-tokens/update-password`,
		passwordTokenUpdateBody,
		options
	);
};

/**
 * List periods
 * @summary List periods
 */
export const periodIndex = <TData = AxiosResponse<PeriodIndex200>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/periods`, options);
};

/**
 * Create a new period
 * @summary Create a new period
 */
export const periodCreate = <TData = AxiosResponse<Period>>(
	user: number,
	periodCreateBody: PeriodCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/${user}/periods`, periodCreateBody, options);
};

/**
 * Update a period
 * @summary Update a period
 */
export const periodUpdate = <TData = AxiosResponse<Period>>(
	user: number,
	period: number,
	periodUpdateBody: PeriodUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(
		`/users/${user}/periods/${period}`,
		periodUpdateBody,
		options
	);
};

/**
 * Delete a period
 * @summary Delete a period
 */
export const periodDelete = <TData = AxiosResponse<PeriodDelete200>>(
	user: number,
	period: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/users/${user}/periods/${period}`, options);
};

/**
 * List profiles
 * @summary List profiles
 */
export const profileIndex = <TData = AxiosResponse<ProfileIndex200>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/profiles`, options);
};

/**
 * Create a new user profile
 * @summary Create a new user profile
 */
export const profileCreate = <TData = AxiosResponse<Profile>>(
	user: number,
	profileCreateBody: ProfileCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/${user}/profiles`, profileCreateBody, options);
};

/**
 * Delete a profile
 * @summary Delete a profile
 */
export const profileDelete = <TData = AxiosResponse<ProfileDelete200>>(
	user: number,
	profile: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/users/${user}/profiles/${profile}`, options);
};

/**
 * Get the profile goals for a user
 * @summary Get the latest profile for a user
 */
export const profileLatest = <TData = AxiosResponse<Profile>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/profiles/latest`, options);
};

/**
 * Get all reviews for a user
 * @summary Get all reviews for a user
 */
export const reviewIndex = <TData = AxiosResponse<ReviewIndex200>>(
	user: number,
	params?: ReviewIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/reviews`, {
		params,
		...options,
	});
};

/**
 * Create a review
 * @summary Create a review
 */
export const reviewCreate = <TData = AxiosResponse<Review>>(
	user: number,
	reviewCreateBody: ReviewCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/${user}/reviews`, reviewCreateBody, options);
};

/**
 * Get one review for user
 * @summary Get one review for user
 */
export const reviewShow = <TData = AxiosResponse<Review>>(
	user: number,
	review: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/reviews/${review}`, options);
};

/**
 * Update an existing review
 * @summary Update an existing review
 */
export const reviewUpdate = <TData = AxiosResponse<Review>>(
	user: number,
	review: number,
	reviewUpdateBody: ReviewUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(
		`/users/${user}/reviews/${review}`,
		reviewUpdateBody,
		options
	);
};

/**
 * Delete a review
 * @summary Delete a review
 */
export const reviewDelete = <TData = AxiosResponse<ReviewDelete200>>(
	user: number,
	review: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/users/${user}/reviews/${review}`, options);
};

/**
 * Get latest review for a user
 * @summary Get latest review for a user
 */
export const reviewLatest = <TData = AxiosResponse<Review>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/reviews/latest`, options);
};

/**
 * List all tags
 * @summary List all tags
 */
export const tagIndex = <TData = AxiosResponse<TagIndex200>>(
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/tags`, options);
};

/**
 * List all tasks
 * @summary List all tasks
 */
export const taskIndex = <TData = AxiosResponse<TaskIndex200>>(
	params?: TaskIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/tasks`, {
		params,
		...options,
	});
};

/**
 * Create a new task
 * @summary Create a new task
 */
export const taskCreate = <TData = AxiosResponse<Task>>(
	taskCreateBody: TaskCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/tasks`, taskCreateBody, options);
};

/**
 * Get one task
 * @summary Get one task
 */
export const taskShow = <TData = AxiosResponse<Task>>(
	task: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/tasks/${task}`, options);
};

/**
 * Update a task
 * @summary Update a task
 */
export const taskUpdate = <TData = AxiosResponse<Task>>(
	task: number,
	taskUpdateBody: TaskUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(`/tasks/${task}`, taskUpdateBody, options);
};

/**
 * Delete a task
 * @summary Delete a task
 */
export const taskDelete = <TData = AxiosResponse<TaskDelete200>>(
	task: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/tasks/${task}`, options);
};

/**
 * List tasks for user
 * @summary List tasks for user
 */
export const taskIndexByUser = <TData = AxiosResponse<TaskIndexByUser200>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}/tasks`, options);
};

/**
 * Create an answer to a task
 * @summary Create an answer to a task
 */
export const taskAnswerCreate = <TData = AxiosResponse<Answer>>(
	user: number,
	task: number,
	taskAnswerCreateBody: TaskAnswerCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(
		`/users/${user}/tasks/${task}/answers`,
		taskAnswerCreateBody,
		options
	);
};

/**
 * Update an answer
 * @summary Update an answer
 */
export const taskAnswerUpdate = <TData = AxiosResponse<Answer>>(
	user: number,
	task: number,
	answer: number,
	taskAnswerUpdateBody: TaskAnswerUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(
		`/users/${user}/tasks/${task}/answers/${answer}`,
		taskAnswerUpdateBody,
		options
	);
};

/**
 * Update photo for an answer
 * @summary Update photo for an answer
 */
export const taskAnswerUpdatePhoto = <TData = AxiosResponse<Answer>>(
	user: number,
	task: number,
	answer: number,
	taskAnswerUpdatePhotoBody: TaskAnswerUpdatePhotoBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/tasks/${task}/answers/${answer}/photo`,
		taskAnswerUpdatePhotoBody,
		options
	);
};

/**
 * Get all teams
 * @summary Get all teams
 */
export const teamIndex = <TData = AxiosResponse<TeamIndex200>>(
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/teams`, options);
};

/**
 * Create a new team
 * @summary Create a new team
 */
export const teamCreate = <TData = AxiosResponse<Team>>(
	teamCreateBody: TeamCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/teams`, teamCreateBody, options);
};

/**
 * Get one team
 * @summary Get one team
 */
export const teamShow = <TData = AxiosResponse<Team>>(
	team: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/teams/${team}`, options);
};

/**
 * Update a team
 * @summary Update a team
 */
export const teamUpdate = <TData = AxiosResponse<Team>>(
	team: number,
	teamUpdateBody: TeamUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.put(`/teams/${team}`, teamUpdateBody, options);
};

/**
 * Delete a team
 * @summary Delete a team
 */
export const teamDelete = <TData = AxiosResponse<TeamDelete200>>(
	team: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/teams/${team}`, options);
};

/**
 * List all user information
 * @summary List all users
 */
export const userIndex = <TData = AxiosResponse<UserIndex200>>(
	params?: UserIndexParams,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users`, {
		params,
		...options,
	});
};

/**
 * Create a new user
 * @summary Create a new user
 */
export const userCreate = <TData = AxiosResponse<User>>(
	userCreateBody: UserCreateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users`, userCreateBody, options);
};

/**
 * Create a new user using an iOS app store receipt
 * @summary Create a new user using an iOS app store receipt
 */
export const userCreateAppStore = <TData = AxiosResponse<User>>(
	userCreateAppStoreBody: UserCreateAppStoreBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.post(`/users/app-store`, userCreateAppStoreBody, options);
};

/**
 * Get one user
 * @summary Get one user
 */
export const userShow = <TData = AxiosResponse<User>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/users/${user}`, options);
};

/**
 * Delete a customer
 * @summary Delete a customer
 */
export const userDelete = <TData = AxiosResponse<UserDelete200>>(
	user: number,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.delete(`/users/${user}`, options);
};

/**
 * Update the user email
 * @summary Update the user email
 */
export const userEmailUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userEmailUpdateBody: UserEmailUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/update-email`,
		userEmailUpdateBody,
		options
	);
};

/**
 * Update the user name
 * @summary Update the user name
 */
export const userNameUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userNameUpdateBody: UserNameUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(`/users/${user}/update-name`, userNameUpdateBody, options);
};

/**
 * Update the user role
 * @summary Update the user role
 */
export const userRoleUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userRoleUpdateBody: UserRoleUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(`/users/${user}/update-role`, userRoleUpdateBody, options);
};

/**
 * Update the user's team
 * @summary Update the user's team
 */
export const userTeamUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userTeamUpdateBody: UserTeamUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(`/users/${user}/update-team`, userTeamUpdateBody, options);
};

/**
 * Update the user's spouse
 * @summary Update the user's spouse
 */
export const userSpouseUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userSpouseUpdateBody: UserSpouseUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/update-spouse`,
		userSpouseUpdateBody,
		options
	);
};

/**
 * Update the user notes
 * @summary Update the user notes
 */
export const userNotesUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userNotesUpdateBody: UserNotesUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/update-notes`,
		userNotesUpdateBody,
		options
	);
};

/**
 * Update the user push token
 * @summary Update the user push token
 */
export const userPushTokenUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userPushTokenUpdateBody: UserPushTokenUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/update-push-token`,
		userPushTokenUpdateBody,
		options
	);
};

/**
 * Update the user photo
 * @summary Update the user photo
 */
export const userPhotoUpdate = <TData = AxiosResponse<User>>(
	user: number,
	userPhotoUpdateBody: UserPhotoUpdateBody,
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.patch(
		`/users/${user}/update-photo`,
		userPhotoUpdateBody,
		options
	);
};

/**
 * Check API status
 * @summary Check API status
 */
export const utilHealth = <TData = AxiosResponse<UtilHealth200>>(
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/util/health`, options);
};

/**
 * List all icelandic postal codes
 * @summary List all icelandic postal codes
 */
export const utilPostalCodes = <TData = AxiosResponse<UtilPostalCodes200>>(
	options?: AxiosRequestConfig
): Promise<TData> => {
	return axios.get(`/util/postal-codes`, options);
};

export type AuthLoginResult = AxiosResponse<UserLogin>;
export type AuthLogoutResult = AxiosResponse<AuthLogout200>;
export type CourseCurrentResult = AxiosResponse<Course>;
export type DiaryIndexResult = AxiosResponse<DiaryIndex200>;
export type DiaryCreateResult = AxiosResponse<Diary>;
export type DiaryUpdateResult = AxiosResponse<Diary>;
export type DiarySubmitResult = AxiosResponse<Diary>;
export type DiaryReviewResult = AxiosResponse<Diary>;
export type DiaryCommentCreateResult = AxiosResponse<Comment>;
export type DiaryCommentReadResult = AxiosResponse<Comment>;
export type DocumentUploadFileResult = AxiosResponse<Document>;
export type DocumentEmbedVideoResult = AxiosResponse<Document>;
export type GoalCreateResult = AxiosResponse<Goal>;
export type GoalLatestResult = AxiosResponse<Goal>;
export type MeasurementIndexResult = AxiosResponse<MeasurementIndex200>;
export type MeasurementCreateResult = AxiosResponse<Measurement>;
export type MeasurementUpdateResult = AxiosResponse<Measurement>;
export type MeasurementUpdatePhotoResult = AxiosResponse<Measurement>;
export type NotificationIndexResult = AxiosResponse<NotificationIndex200>;
export type NotificationCreateResult = AxiosResponse<Notification>;
export type NotificationShowResult = AxiosResponse<Notification>;
export type NotificationUpdateResult = AxiosResponse<Notification>;
export type NotificationDeleteResult = AxiosResponse<NotificationDelete200>;
export type NotificationScheduleResult = AxiosResponse<Notification>;
export type NotificationSendResult = AxiosResponse<Notification>;
export type NotificationUserIndexResult =
	AxiosResponse<NotificationUserIndex200>;
export type NotificationUserShowResult = AxiosResponse<Notification>;
export type NotificationUserReadResult = AxiosResponse<NotificationUserRead200>;
export type PageIndexResult = AxiosResponse<PageIndex200>;
export type PageCreateResult = AxiosResponse<Page>;
export type PageShowResult = AxiosResponse<Page>;
export type PageUpdateResult = AxiosResponse<Page>;
export type PageDeleteResult = AxiosResponse<PageDelete200>;
export type PageItemCreateResult = AxiosResponse<PageItem>;
export type PageItemUpdateResult = AxiosResponse<PageItem>;
export type PageItemDeleteResult = AxiosResponse<PageItemDelete200>;
export type PasswordTokenCreateResult = AxiosResponse<void>;
export type PasswordTokenVerifyResult = AxiosResponse<void>;
export type PasswordTokenUpdateResult = AxiosResponse<UserLogin>;
export type PeriodIndexResult = AxiosResponse<PeriodIndex200>;
export type PeriodCreateResult = AxiosResponse<Period>;
export type PeriodUpdateResult = AxiosResponse<Period>;
export type PeriodDeleteResult = AxiosResponse<PeriodDelete200>;
export type ProfileIndexResult = AxiosResponse<ProfileIndex200>;
export type ProfileCreateResult = AxiosResponse<Profile>;
export type ProfileDeleteResult = AxiosResponse<ProfileDelete200>;
export type ProfileLatestResult = AxiosResponse<Profile>;
export type ReviewIndexResult = AxiosResponse<ReviewIndex200>;
export type ReviewCreateResult = AxiosResponse<Review>;
export type ReviewShowResult = AxiosResponse<Review>;
export type ReviewUpdateResult = AxiosResponse<Review>;
export type ReviewDeleteResult = AxiosResponse<ReviewDelete200>;
export type ReviewLatestResult = AxiosResponse<Review>;
export type TagIndexResult = AxiosResponse<TagIndex200>;
export type TaskIndexResult = AxiosResponse<TaskIndex200>;
export type TaskCreateResult = AxiosResponse<Task>;
export type TaskShowResult = AxiosResponse<Task>;
export type TaskUpdateResult = AxiosResponse<Task>;
export type TaskDeleteResult = AxiosResponse<TaskDelete200>;
export type TaskIndexByUserResult = AxiosResponse<TaskIndexByUser200>;
export type TaskAnswerCreateResult = AxiosResponse<Answer>;
export type TaskAnswerUpdateResult = AxiosResponse<Answer>;
export type TaskAnswerUpdatePhotoResult = AxiosResponse<Answer>;
export type TeamIndexResult = AxiosResponse<TeamIndex200>;
export type TeamCreateResult = AxiosResponse<Team>;
export type TeamShowResult = AxiosResponse<Team>;
export type TeamUpdateResult = AxiosResponse<Team>;
export type TeamDeleteResult = AxiosResponse<TeamDelete200>;
export type UserIndexResult = AxiosResponse<UserIndex200>;
export type UserCreateResult = AxiosResponse<User>;
export type UserCreateAppStoreResult = AxiosResponse<User>;
export type UserShowResult = AxiosResponse<User>;
export type UserDeleteResult = AxiosResponse<UserDelete200>;
export type UserEmailUpdateResult = AxiosResponse<User>;
export type UserNameUpdateResult = AxiosResponse<User>;
export type UserRoleUpdateResult = AxiosResponse<User>;
export type UserTeamUpdateResult = AxiosResponse<User>;
export type UserSpouseUpdateResult = AxiosResponse<User>;
export type UserNotesUpdateResult = AxiosResponse<User>;
export type UserPushTokenUpdateResult = AxiosResponse<User>;
export type UserPhotoUpdateResult = AxiosResponse<User>;
export type UtilHealthResult = AxiosResponse<UtilHealth200>;
export type UtilPostalCodesResult = AxiosResponse<UtilPostalCodes200>;
